var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconsAudit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.2621 5.47519H17.6996V3.3377C17.67 2.74394 17.4621 2.23926 17.0762 1.82363C16.6605 1.4377 16.1559 1.22988 15.5621 1.2002H8.43711C7.84335 1.22988 7.33868 1.4377 6.92305 1.82363C6.53711 2.23926 6.32929 2.74394 6.29961 3.3377V5.47519H2.73711C2.14335 5.50488 1.63867 5.7127 1.22305 6.09863C0.83711 6.51426 0.629297 7.01894 0.599609 7.6127V12.6002H23.3996V7.6127C23.37 7.01894 23.1621 6.51426 22.7762 6.09863C22.3605 5.7127 21.8559 5.50488 21.2621 5.47519ZM15.5621 5.47519H8.43711V3.3377H15.5621V5.47519Z",
    fill: "#3CDBC1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8496 16.0498C14.8199 16.5186 14.5824 16.7686 14.1371 16.7998H9.86211C9.4168 16.7686 9.17929 16.5186 9.14961 16.0498V13.7998H0.599609V20.5498C0.629297 21.1749 0.83711 21.706 1.22305 22.1436C1.63867 22.5498 2.14335 22.7686 2.73711 22.7998H21.2621C21.8559 22.7686 22.3605 22.5498 22.7762 22.1436C23.1621 21.706 23.37 21.1749 23.3996 20.5498V13.7998H14.8496V16.0498Z",
    fill: "#3CDBC1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsAudit);
export default __webpack_public_path__ + "static/media/icons_audit.1cbae5c0.svg";
export { ForwardRef as ReactComponent };